import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/aregncapital/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/app/contact/components/ContactTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/aregncapital/src/components/ui/AppLogo.tsx");
